module.exports = __webpack_public_path__ + "9e8324ca4e2a7ce46dc95b02d413ede7.pdf";